export const requesterUpdatesFilter = requestId => ({
  where: {
    requestId,
  },
  include: [{ relation: 'type' }],
  order: ['created desc'],
  limit: 1,
});
